var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivejournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B0EA",
    d: "M15.861,1.919c-1.972,0-3.846,0.411-5.547,1.146L7.245,0H7.238 C3.998,1.419,1.401,4.029,0,7.28l3.074,3.071l-0.002,0.003c-0.742,1.704-1.184,3.56-1.184,5.538 c0,7.72,6.255,13.974,13.973,13.974c7.715,0,13.972-6.256,13.972-13.974C29.833,8.176,23.577,1.919,15.861,1.919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#15374C",
    d: "M14.437,21.696c1.4-3.251,3.999-5.861,7.238-7.281h0.002L10.316,3.071 L10.311,3.07c-3.242,1.42-5.839,4.029-7.239,7.282L14.437,21.696z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#15374C",
    d: "M22.489,18.29c-1.882,0.824-3.39,2.343-4.205,4.229l5.306,1.097L22.489,18.29z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.489,18.292c-0.427-2.037-0.812-3.876-0.812-3.876l-0.004,0.001 c-3.238,1.42-5.836,4.029-7.237,7.28l3.848,0.822C19.101,20.639,20.612,19.114,22.489,18.292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivejournal);
export default __webpack_public_path__ + "static/media/livejournal.34042511ab07b89bbc40b67a003cb6f1.svg";
export { ForwardRef as ReactComponent };